import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader, Input, Dropdown} from 'semantic-ui-react';
import {orderOptions, inputFields, dropdownFields, PNC} from '../static/commonStructures';
import {getDeepCopyOfBidimensionalArray} from '../utils';
import {Actions} from '../../../common/actions';

const DATA_FIELDS = inputFields.concat(dropdownFields);

class EditOrclonePartNumberCodeTable extends Component {
  handleOnBlur(fieldValue, columnName = PNC) {
    this.getPncRepeatedSet(fieldValue, columnName);
  }

  getPncRepeatedSet(fieldValue, columnName = PNC) {
    if (columnName === PNC) {
      this.props.getPncByCode(fieldValue || '__');
    }
  }

  getFocusState(columnDetail) {
    const {editPnc} = this.props.location.state;
    return (columnDetail.name === 'Nombre' && editPnc);
  }

  handleChangeValue(event, position, data = null) {
    const {rowIndex, columnIndex} = position;
    const {tableValues} = this.props;
    const updatedTableValues = getDeepCopyOfBidimensionalArray(tableValues);
    const updatedData = data ? data.value : event.target.value;
    updatedTableValues[rowIndex][columnIndex] = updatedData.toUpperCase();
    this.props.handleTableValuesState(updatedTableValues);
  }

  renderOrder(element, rowIndex) {
    return dropdownFields.map((item) => {
      const columnIndex = DATA_FIELDS.findIndex((fieldToDisplay) => {
        return fieldToDisplay.name === item.name;
      });
      const position = {'rowIndex': rowIndex, 'columnIndex': columnIndex};
      return (
        <Table.Cell
          key={`cell${rowIndex.toString().concat(columnIndex)}`}
          style={{'width': item.width}}
        >
          <Dropdown
            key={`selector${rowIndex.toString().concat(columnIndex)}`}
            style={{'width': dropdownFields.width}}
            selection
            upward
            compact
            value={element[columnIndex] || 'S'}
            options={orderOptions}
            onChange = {(event, data) => this.handleChangeValue(event, position, data)}
          />
        </Table.Cell>
      );
    });
  }

  renderRowContent(element, rowIndex) {
    const columnDetails = DATA_FIELDS.filter((item) => {
      return (item.name !== 'Pedido' && item.name !== PNC);
    });
    return columnDetails.map((columnDetail, columnIndex) => {
      const position = {'rowIndex': rowIndex, 'columnIndex': columnIndex + 1};
      return (
        <Table.Cell key={columnIndex + 1} style={{'width': columnDetail.width}}>
          <Input
            focus={this.getFocusState(columnDetail)}
            required={columnDetail.required}
            maxLength={columnDetail.maxLength}
            style={{'width': columnDetail.width}}
            key={rowIndex.toString().concat(columnIndex + 1)}
            value={element[columnIndex + 1] || ''}
            onChange = {(event) => this.handleChangeValue(event, position)}
            inline='centered'
          />
        </Table.Cell>
      );
    });
  }

  renderPncAlreadyInDatabase(pncExistsInDatabase) {
    if (pncExistsInDatabase) {
      return (
        <div className='invalid-value'>
        Actualizando PNC
        </div>
      );
    }
  }

  renderPncField(element, rowIndex) {
    const {editPnc} = this.props.location.state;
    const inputFieldDetail = DATA_FIELDS.filter((item) => {
      return (item.name === PNC);
    });
    
    if (!editPnc) {
      return inputFieldDetail.map((columnDetail, columnIndex) => {
        const {pncRecord} = this.props;
        const pncExistsInDatabase = pncRecord[0] ? pncRecord[0].partNumberCode === element[columnIndex] : false;
        const position = {'rowIndex': rowIndex, 'columnIndex': columnIndex};
        return (
          <Table.Cell key={columnIndex} style={{'width': columnDetail.width}}>
            <Input
              focus={true}
              required={columnDetail.required}
              maxLength={columnDetail.maxLength}
              style={{'width': columnDetail.width}}
              key={rowIndex.toString().concat(columnIndex)}
              value={element[columnIndex] || ''}
              onChange = {(event) => this.handleChangeValue(event, position)}
              inline='centered'
              onBlur={() => this.handleOnBlur(element[columnIndex], columnDetail.name)}
            />
            {this.renderPncAlreadyInDatabase(pncExistsInDatabase)}
          </Table.Cell>
        );
      });
    }

    return inputFieldDetail.map((columnDetail, columnIndex) => {
      return (
        <Table.Cell key={columnIndex} style={{'width': columnDetail.width}}>
          {element[columnIndex]}
        </Table.Cell>
      );
    });
  }

  renderPncParsedData() {
    const {tableValues} = this.props;
    if (!tableValues) {
      return null;
    }
    return tableValues.map((element, row) => {
      return (
        <Table.Row key={row} inline='centered'>
          {this.renderPncField(element, row)}
          {this.renderRowContent(element, row)}
          {this.renderOrder(element, row)}
        </Table.Row>
      );
    });
  }

  renderLoaderOrPncParsedData() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%' textAlign='center'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    return this.renderPncParsedData();
  }

  renderTableHeader() {
    return (
      <Table.Row>
        {DATA_FIELDS.map((element, index) => {
          return (
            <Table.HeaderCell
              textAlign='center'
              key={index}>{element.name}
            </Table.HeaderCell>
          );
        })}
      </Table.Row>
    );
  }

  render() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          {this.renderTableHeader()}
        </Table.Header>
        <Table.Body>
          {this.renderLoaderOrPncParsedData()}
        </Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'pncRecord': state.partNumberCodeInstance.record,
    'loading': state.partNumberCodeInstance.loading,
  };
};

const {getPncByCode} = Actions;

export default connect(mapStateToProps, {
  getPncByCode,
})(EditOrclonePartNumberCodeTable);
